import 'semantic-ui-css/components/form.min.css'
import 'semantic-ui-form/form.min'

$.fn.form.settings.rules.symfonyHtml5Email = function (value) {
  if (!value) return true

  // https://github.com/symfony/symfony/blob/422893b0a21f69c2c01970595969e56ab986917a/src/Symfony/Component/Validator/Constraints/EmailValidator.php#L30
  // This differs from browser HTML5 validation in that it requires a top-level domain
  // https://symfony.com/doc/current/reference/constraints/Email.html#mode
  const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

  return regex.test(value)
}

$.fn.form.settings.rules.mobileNumber = function (value) {
  if (!value) return true

  const regex = /^\+[0-9]+$/

  return regex.test(value)
}
